module.exports = __webpack_public_path__ + "img/logotipo_color.9d3ea750.svg";